import { Box, Typography } from '@mui/material';

export default function WhatBox({ title, description, image }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <img src={image} alt={title} style={{ width: '100%' }} />

      <Typography
        sx={{
          color: '#1E1E1E',
          fontWeight: '700',
          mt: '15px',
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          color: '#1E1E1E',
          fontWeight: '400',
        }}
      >
        {description}
      </Typography>
    </Box>
  );
}
